var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "elevation-8",
      staticStyle: { "z-index": "8" },
      attrs: {
        app: "",
        "mini-variant": _vm.mini,
        stateless: "",
        "hide-overlay": "",
        fixed: "",
        temporary: ""
      },
      nativeOn: {
        mouseenter: function($event) {
          return _vm.showFullMenu($event)
        },
        mouseleave: function($event) {
          return _vm.hideFullMenu($event)
        }
      },
      model: {
        value: _vm.drawer,
        callback: function($$v) {
          _vm.drawer = $$v
        },
        expression: "drawer"
      }
    },
    [
      _c("main-menu-header"),
      _c(
        "v-list",
        { staticStyle: { "white-space": "nowrap" } },
        [
          _c(
            "v-list-item",
            { attrs: { href: _vm.externalAddresses("SEARCH") } },
            [
              _c("v-list-item-action", [
                _c("img", {
                  attrs: {
                    src: "/img/menu-icons/search-engine.svg",
                    alt: "",
                    width: "28"
                  }
                })
              ]),
              _c("v-list-item-content", [_vm._v("Wyszukiwarka")])
            ],
            1
          ),
          _c(
            "v-list-item",
            { attrs: { href: _vm.externalAddresses("BOOKING") } },
            [
              _c("v-list-item-action", [
                _c("img", {
                  attrs: {
                    src: "/img/menu-icons/bookings.svg",
                    alt: "",
                    width: "28"
                  }
                })
              ]),
              _c("v-list-item-content", [_vm._v("Rezerwacje")])
            ],
            1
          ),
          _c(
            "v-list-item",
            { attrs: { to: "/delegation" } },
            [
              _c("v-list-item-action", [
                _c("img", {
                  attrs: {
                    src: "/img/menu-icons/business-travel.svg",
                    alt: "",
                    width: "28"
                  }
                })
              ]),
              _c("v-list-item-content", [_vm._v("Delegacje")])
            ],
            1
          ),
          _c(
            "v-list-item",
            { attrs: { href: _vm.externalAddresses("MY_COMPANY") } },
            [
              _c("v-list-item-action", [
                _c("img", {
                  attrs: {
                    src: "/img/menu-icons/companies.svg",
                    alt: "",
                    width: "28"
                  }
                })
              ]),
              _c("v-list-item-content", [_vm._v("Moja firma")])
            ],
            1
          ),
          _c(
            "v-list-item",
            { attrs: { to: "/invoices" } },
            [
              _c("v-list-item-action", [
                _c("img", {
                  attrs: {
                    src: "/img/menu-icons/invoice.svg",
                    alt: "",
                    width: "28"
                  }
                })
              ]),
              _c("v-list-item-content", [_vm._v("Faktury")])
            ],
            1
          ),
          _c(
            "v-list-item",
            { attrs: { to: "/delegation-info" } },
            [
              _c("v-list-item-action", [
                _c("img", {
                  attrs: {
                    src: "/img/menu-icons/travel-policy.svg",
                    alt: "",
                    width: "28"
                  }
                })
              ]),
              _c("v-list-item-content", [_vm._v("Polityka podróży")])
            ],
            1
          ),
          _c(
            "v-list-item",
            { attrs: { href: _vm.externalAddresses("ACCOUNT_SETTINGS") } },
            [
              _c("v-list-item-action", [
                _c("img", {
                  attrs: {
                    src: "/img/menu-icons/user-settings.svg",
                    alt: "",
                    width: "28"
                  }
                })
              ]),
              _c("v-list-item-content", [_vm._v("Ustawienia konta")])
            ],
            1
          ),
          _vm.is_user_logged()
            ? _c(
                "v-list-item",
                {
                  staticStyle: {
                    "border-top": "1px solid rgba(0,0,0,.12)",
                    "margin-top": "8px",
                    "padding-top": "8px"
                  },
                  attrs: { to: "/logout" }
                },
                [
                  _c("v-list-item-action", [
                    _c("img", {
                      attrs: {
                        src: "/img/menu-icons/logout.svg",
                        alt: "",
                        width: "28"
                      }
                    })
                  ]),
                  _c("v-list-item-content", [_vm._v("Wyloguj się")])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }